import {
  AutocompleteInput,
  BooleanInput,
  Edit,
  ReferenceInput,
  SimpleForm,
} from "react-admin";
import { statusChoices } from "../../utils/driver-schedule";
import DateFieldComponent from "../components/date-field-component";
import DivisionInput from "../components/division-input";
import { SmartSelect } from "../components/smart-select";
import { createTrucksFilterQuery } from "./common";

export const DriverScheduleEdit = (props: any) => (
  <Edit {...props}>
    <SimpleForm>
      <ReferenceInput source="driver" reference="fleetAssignments">
        <AutocompleteInput
          fullWidth
          optionText={(option) =>
            `${option.truck.licensePlate ?? option.truck.plate} - ${
              option.driver === null ? "未知司机" : option.driver.name
            } - ${option.source ?? `线下收集`}`
          }
          label="选择司机与货车（可输入车牌号快速查找）"
          filterToQuery={createTrucksFilterQuery}
          noOptionsText="无选项"
          style={{ maxWidth: "480px" }}
        />
      </ReferenceInput>
      <DivisionInput source="origin" label="始发站" />
      <DivisionInput source="destination" label="终点站" />
      <DateFieldComponent source="departureDate" label="出发日期" />
      <DateFieldComponent source="arrivalDate" label="到达日期" />
      <SmartSelect
        source="status"
        label="状态"
        choices={statusChoices}
        optionText="name"
        optionValue="id"
      />
      <BooleanInput source="isReturnTrip" label="为返程路线" />
    </SimpleForm>
  </Edit>
);
